import { PipeTransform, Pipe } from '@angular/core';
import * as d3 from 'd3';
import { RoutingService } from '../service/routing.service';

/**
 * This pipe define the sentiment color
 */

@Pipe({ name: 'color' })
export class ColorPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor(_routing?: RoutingService) {}
  transform(value: string | number | null | undefined): string {
    if (value !== undefined) {
      if (
        value === 'nf' ||
        value === 'null' ||
        value === null ||
        value === -1
      ) {
        return '#a3a3a3';
      }
      if (value === 'pos' || value === 'buy') {
        value = 1;
      }
      if (value === 'neu') {
        value = 0.5;
      }
      if (value === 'neg' || value === 'sell') {
        value = 0;
      }
      const numeric = Number(Number(value).toFixed(2));
      const colorScale = d3
        .scaleLinear<string>()
        .domain([0, 0.33, 0.67, 1])
        .range(['#FF4C23', '#FF7700', '#FEF554', '#50DF6A']);
      return colorScale(numeric) ?? 'rgb(120,120,120)';
    } else {
      return 'rgb(120,120,120)';
    }
  }
}
